import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import user from 'redux/user';
import AuthLayout from 'components/molecules/AuthLayout';
import CustomForm from 'components/molecules/CustomForm';
import { fields } from './formField';

import './index.scss';

const Login = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation(['login-screen', 'alert']);
  const errors = useSelector(user.selectors.getErrors);

  const onLogin = (values) => {
    dispatch(user.thunks.signin(values));
  };

  // keySeparator: false — API errors contain dots, which i18next would
  // otherwise read as nested keys and leave untranslated.
  const errorMessage = t(`alert:${errors}`, { keySeparator: false });

  return (
    <AuthLayout title={t('login-screen:title')} subtitle={t('login-screen:subtitle')}>
      <CustomForm
        fields={fields}
        submitLabel={t('login-screen:submit')}
        initialValues={{ remember: false }}
        validateStatus={errors && 'error'}
        error={errorMessage}
        onSubmit={onLogin}
        inputStyle="normal"
        localePath="login-screen"
      />
    </AuthLayout>
  );
};

export default Login;
